module.exports = __webpack_public_path__ + "img/privacy.e93c868.svg";